module.exports = __webpack_public_path__ + "assets/img/about12.e07725ce.jpg";